import { create } from "zustand";


type AuthenticationInfo = { accessToken: string };

type AuthStore = {
  loginStatus: boolean;
  setLoginStatus: (loginStatus: boolean) => void;
  // accessToken: string | null;
  // setAccessToken: (accessToken: string | null) => void;
  // setAuthenticationInfo: (info: AuthenticationInfo) => void;
};

export const authStore = create<AuthStore>((set) => ({
  loginStatus: false,
  setLoginStatus: (loginStatus: boolean) => set({ loginStatus }),
  // accessToken: null,
  // setAccessToken: (accessToken: string | null) => set({ accessToken }),
  // setAuthenticationInfo: ({ accessToken }) => set({ accessToken }),
}));
